import styled from 'styled-components';
import { Grid, Select, TextField } from '@material-ui/core';

export const DateInput = styled(TextField)`
  margin: 20px 24px 20px 0;
`;

export const SelectInput = styled(Select)`
  margin: 20px 0;
`;

export const StyledDropzoneArea = styled.div`
  margin-top: 20px;
  padding-left: 15px;
`;

export const UploadButtonZone = styled(Grid)`
  text-align: center;
`;

export const ImagePreview = styled.img`
  width: 100%;
  min-height: 150px;
  max-height: 250px;
`;

export const ReactQuillArea = styled.div`
  max-height: 180px;
  overflow-x: auto;
`;
